import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { Modal } from "react-bootstrap";
import {
  getAllUsers,
  deleteUser,
  getAllUserRoles,
} from "../server/rolesAllApi";
import axios from "axios";

const UsersListLayer = () => {
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [serialNumbers, setSerialNumbers] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [token, setToken] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [selectedRole, setSelectedRole] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const [showModal, setShowModal] = useState(false);
  const [userToAssign, setUserToAssign] = useState(null);
  const [modalDetails, setModalDetails] = useState({
    rolename: "",
    studentId: "",
    user: "",
    roleID: "",
  });

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const storedToken = localStorage.getItem("token");
    setToken(storedToken);
  }, [users]);

  useEffect(() => {
    if (token) {
      fetchUser();
      fetchRoles();
    }
  }, [token, currentPage, itemsPerPage, searchTerm, selectedRole]);

  // useEffect(()=>{
  //   if(!selectedRole){
  //     return;
  //   }
  //   else{
  //     fetchAssignrolesbyrole();
  //   }
  // },[selectedRole])

  // Trigger re-fetch when the component mounts if refresh flag is set
  // useEffect(() => {
  //   if (location.state?.refresh) {
  //     fetchUser();
  //   }
  // }, [location.state]);

  const fetchUser = async () => {
    setLoading(true);
    setError(null);
    try {
      const reqHeader = {
        authorization: `Bearer ${token}`,
      };

      const response = selectedRole
        ? await axios.get(
            `${process.env.REACT_APP_USER_ROLE_BASEURL}/getallusers/${selectedRole}?page=${currentPage}&limit=${rowsPerPage}&search=${searchTerm}
            `,
            { headers: reqHeader }
          )
        : await getAllUsers(currentPage, itemsPerPage, searchTerm, reqHeader);

      const startSerial = (currentPage - 1) * itemsPerPage + 1;
      const usersWithSerial = response.data.data.map((item, index) => ({
        ...item,
        serial: startSerial + index,
        statusToggle: !item.status,
      }));
      setUsers(usersWithSerial);
      setSerialNumbers(usersWithSerial.map((t) => t.serial));
      setTotalItems(response.data.pagination.totalItems);
      setTotalPages(response.data.pagination.totalPages);
    } catch (error) {
      console.error("Failed to fetch users:", error);
      setError("Failed to fetch. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const fetchRoles = () => {
    getAllUserRoles()
      .then((response) => {
        if (Array.isArray(response.data.roles)) {
          setRoles(response.data.roles);
        } else {
          throw new Error("Roles data is not an array");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch roles:", err);
        setError("Failed to fetch. Please try again later.");
        setLoading(false);
      });
  };

  const fetchAssignrolesbyrole = async () => {
    setLoading(true);
    setError(null);
    setTotalItems(0);
    setTotalPages(0);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/getallusers/${selectedRole}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      const startSerial = (currentPage - 1) * itemsPerPage + 1; // Start serial for the current page
      const usersWithSerial = response.data.data.map((item, index) => ({
        ...item,
        serial: startSerial + index, // Calculate serial number correctly
        statusToggle: !item.status,
      }));
      setUsers(usersWithSerial);
      setSerialNumbers(usersWithSerial.map((t) => t.serial));
      setTotalItems(response.data.pagination.totalItems); // Set totalItems for pagination
      setTotalPages(response.data.pagination.totalPages); // Set totalPages for pagination
    } catch (error) {
      console.error("Failed to fetch users:", error);
      setError("Failed to fetch users.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(event.target.value);
    setCurrentPage(1);
  };

  const handleDeleteUser = (user) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete this role?`
    );

    if (confirmDelete) {
      deleteUser(user._id)
        .then((res) => {
          if (res.status === 200) {
            // Refresh the user list after successful deletion
            fetchUser();
          } else {
            // Handle the case where deletion was not successful
            alert(res.err);
          }
        })
        .catch((err) => {
          // Handle any errors that occur during the deletion process
          // console.log(err);
          alert("Failed to save changes. Please try again later.");
        });
    } else {
      // console.log("User deletion canceled");
    }
  };

  // modal

  const handleAssignClick = (user) => {
    setUserToAssign(user);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setUserToAssign(null);
  };

  const handleConfirmAssign = async () => {
    try {
      // console.log("user idddddddd: ", modalDetails.user._id);
      // console.log("selected role: ", modalDetails.roleID);

      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/edit-assign-role/${modalDetails.user._id}`,
        { roleId: modalDetails.roleID, studentId: modalDetails?.user?.studentData?._id }, // Updated payload structure
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status == 200) {
        fetchUser();
        fetchRoles();
        setModalDetails({ rolename: "", studentId: "", user: "", roleID: "" });
        // alert("User role updated successfully.");
        handleCloseModal();
      } else {
        // alert("Failed to update the user role.");
        alert("Failed to save changes. Please try again later.");
      }
    } catch (err) {
      console.error("Error updating user role:", err);
      alert(
        "Failed to save changes. Please try again later."
      );
    }
  };

  const handleRoleChange = async (user, selectedRoleId, studentId) => {
    const rolename = roles.find(
      (role) => role._id === selectedRoleId
    )?.rolename;
    // console.log("user dataaaa : ", user);

    if (rolename === "Student") {
      navigate("/student-create", { state: { user } });
    } else if (rolename === "Trader") {
      // const confirmUpdate = window.confirm(
      //   `Are you sure you want to assign the role "${
      //     roles.find((role) => role._id === selectedRoleId)?.rolename
      //   }" to user "${user.username}"?`
      // );

      let rolename = roles.find(
        (role) => role._id === selectedRoleId
      )?.rolename;

      setModalDetails({
        rolename,
        user,
        roleID: selectedRoleId,
        studentId
      });
      setShowModal(true);
    }
  };

  return (
    <div className="card h-100 p-0 radius-12">
      {loading && (
        <div className="loader-container" style={styles.loaderContainer}>
          <CircularProgress />
        </div>
      )}
      <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
        <div className="d-flex align-items-center flex-wrap gap-3">
          <form
            className="search px-10"
            style={{
              border: "1px solid #6b7280",
              display: "flex",
              alignItems: "center",
              borderRadius: "10px",
            }}
            onSubmit={(e) => e.preventDefault()}
          >
            <Icon
              icon="ion:search-outline"
              className="icon"
              style={{ marginRight: "10px" }}
            />
            <input
              type="text"
              className="bg-base h-40-px"
              name="search"
              onChange={(e) => {
                let value = e.target.value;

                // Remove leading/trailing spaces & allow only alphanumeric and spaces
                value = value.replace(/[^a-zA-Z0-9\s]/g, "").trimStart();

                setSearchTerm(value);
                setCurrentPage(1); // Reset to the first page
              }}
              value={searchTerm}
              placeholder="Search"
            />
          </form>

          {/* <select
          
            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
            defaultValue="Select Status"
          >
            <option value="Select Status" disabled>
              Select Status
            </option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select> */}
          <select
            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
            value={selectedRole}
            onChange={(e) => setSelectedRole(e.target.value)}
          >
            <option value="">Select Roles</option>
            
            {roles.map((role) => (
              <option key={role._id} value={role._id}>
                {role.rolename}
              </option>
            ))}
          </select>
        </div>
        {/* <Link
          to="/add-user"
          className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
        >
          <Icon
            icon="ic:baseline-plus"
            className="icon text-xl line-height-1"
          />
          Add New User
        </Link> */}
      </div>
      <div className="card-body p-24">
        <div className="table-responsive scroll-sm">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr>
                <th scope="col">
                  <div className="d-flex align-items-center gap-10">
                    {/* <div className="form-check style-check d-flex align-items-center">
                      <input
                        className="form-check-input radius-4 border input-form-dark"
                        type="checkbox"
                        name="checkbox"
                        id="selectAll"
                      />
                    </div> */}
                    S.L
                  </div>
                </th>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Phone</th>
                {/* <th scope="col">Rolename</th> */}
                <th scope="col">Source</th>
                <th scope="col">Address</th>
                {/* <th scope="col">Status</th> */}
                <th scope="col">
                  Assign
                </th>
                {/* <th scope="col" className="text-center">
                  Action
                </th> */}
              </tr>
            </thead>
            <tbody>
              {users.length > 0 ? (
                users.map((user, index) => (
                  <tr>
                    <td>
                      <div className="d-flex align-items-center gap-10">
                        {/* <div className="form-check style-check d-flex align-items-center">
                          <input
                            className="form-check-input radius-4 border border-neutral-400"
                            type="checkbox"
                            name="checkbox"
                          />
                        </div> */}
                        {user.serial}
                      </div>
                    </td>

                    <td
                      style={{ whiteSpace: "normal", wordWrap: "break-word" }}
                    >
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                    
                      <div className="d-flex align-items-center">
                        <img
                          src={
                            user?.traderData?.profile_url ||
                            user?.studentData?.profile_url ||
                            user?.guestData?.profile_url ||
                            "assets/images/user-grid/user-grid-img14.png"
                          }
                          alt="Wowdash"
                          className="w-40-px h-40-px rounded-circle flex-shrink-0 me-12 overflow-hidden"
                        />
                        <div className="flex-grow-1">
                          <span className="text-md mb-0 fw-normal text-secondary-light">
                            {user?.traderData?.name ||
                              user?.studentData?.name ||
                              user?.guestData?.name}
                          </span>
                        </div>
                      </div>
                      </span>
                    </td>
                    <td
                      style={{ whiteSpace: "normal", wordWrap: "break-word" }}
                    >
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                      {user.email}
                      </span>
                    </td>

                    
                    <td style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                        {user?.traderData?.phone ||
                          user?.traderData?.mobile ||
                          user?.studentData?.mobile ||
                          user?.studentData?.phone ||
                          user?.guestData?.phone ||
                          user?.guestData?.mobile}
                      </span>
                    </td>
                    {/* <td>{user?.role?.rolename}</td> */}
                    <td style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                    <span className="text-md mb-0 fw-normal text-secondary-light">
                      {user?.traderData?.sourse ||
                        user?.studentData?.sourse ||
                        user?.guestData?.sourse ||
                        user?.traderData?.source ||
                        user?.studentData?.source ||
                        user?.guestData?.source}
                        </span>
                    </td>
                    <td style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                      <span className="text-md mb-0 fw-normal text-secondary-light">
                      {user?.traderData?.address ||
                        user?.studentData?.address ||
                        user?.guestData?.address}
                        </span>
                    </td>

                    <td>
                      <div className="dropdown">
                        {
                        user?.roleData?.rolename === "Trader" ? (
                          // If role is Student or Trader, display text instead of select
                          <span>{user?.roleData?.rolename}</span>
                        ) : (
                          <select
                            className="form-select"
                            value={user?.roleData?._id || ""} // Ensure it selects the correct role by its ID
                            onChange={(e) =>
                              handleRoleChange(user, e.target.value, user?.studentData?._id)
                            }
                          >
                            <option value="" disabled>
                              {user?.roleData?.rolename || "Select Role"}
                            </option>
                            {roles?.map((role) => (
                              <option
                                key={role._id}
                                value={role._id}
                                hidden={role.rolename === "Guest"}
                              >
                                {role.rolename}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>
                    </td>

                    {/* <td className="text-center">
                      <div className="d-flex align-items-center gap-10 justify-content-center">
                        
                        <button
                          type="button"
                          className="remove-item-btn bg-danger-focus bg-hover-danger-200 text-danger-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          onClick={() => handleDeleteUser(user)}
                        >
                          <Icon
                            icon="fluent:delete-24-regular"
                            className="menu-icon"
                          />
                        </button>
                      </div>
                    </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No user found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
          <span>
            Showing{" "}
            {users.length === 0
              ? "0"
              : `${(currentPage - 1) * itemsPerPage + 1}`}{" "}
            to {Math.min(currentPage * itemsPerPage, totalItems)} of{" "}
            {totalItems} entries
          </span>

          <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
            {/* Previous Button */}
            <li className="page-item">
              <Link
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                to="#"
                onClick={() => handlePageChange(currentPage - 1)}
                style={{
                  pointerEvents: currentPage === 1 ? "none" : "auto",
                  opacity: currentPage === 1 ? 0.5 : 1,
                }}
              >
                <Icon icon="ep:d-arrow-left" />
              </Link>
            </li>

            {/* Current Page Number */}
            <li className="page-item">
              <span className="page-link bg-primary-600 text-white fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md">
                {currentPage}
              </span>
            </li>

            {/* Next Button */}
            <li className="page-item">
              <Link
                className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px text-md"
                to="#"
                onClick={() => handlePageChange(currentPage + 1)}
                style={{
                  pointerEvents: currentPage === totalPages ? "none" : "auto",
                  opacity: currentPage === totalPages ? 0.5 : 1,
                }}
              >
                <Icon icon="ep:d-arrow-right" />
              </Link>
            </li>
          </ul>
        </div>
        <Modal
          show={showModal}
          onHide={handleCloseModal}
          centered
          backdrop="static"
          size="sm"
        >
          <div className="modal-content radius-16 bg-base">
            <div className="modal-body p-24 text-center">
              <span className="mb-16 fs-1 line-height-1 text-danger d-block">
                <Icon icon="fluent:delete-24-regular" className="menu-icon" />
              </span>
              <h6 className="text-lg fw-semibold text-primary-light mb-0">
                {`Are you sure you want to Assign "${modalDetails?.user?.username}" to "${modalDetails?.rolename}"`}
              </h6>
              <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                <button
                  type="button"
                  onClick={handleCloseModal}
                  className="w-50 border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={handleConfirmAssign}
                  className="w-50 btn btn-primary border border-primary-600 text-md px-24 py-12 radius-8"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </div>
  );
};
// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};
export default UsersListLayer;
